import { backHandler, headerCount, headerTitle, refreshHandler, headerSelectedCount } from '../reducers/reducer'
import store from '../stores/app-store'

const setHeaderTitle = (title?: string) => {
    store.dispatch(headerTitle(title))
}

const setHeaderCount = (count?: number) => {
    store.dispatch(headerCount(count))
}

const setRefreshHandler = (RefreshHandler?: () => void) => {
    store.dispatch(refreshHandler(RefreshHandler))
}

const setBackHandler = (BackHandler?: () => void) => {
    store.dispatch(backHandler(BackHandler))
}
const setSelectedCount = (count?: number) => {
    store.dispatch(headerSelectedCount(count))
}

export { setBackHandler, setHeaderCount, setHeaderTitle, setRefreshHandler, setSelectedCount }

